module.exports = __webpack_public_path__ + "images/logo_android.png?e2b7b65112517cbe56f49ce6dae97bf7";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/logo_android.png
// module id = 997
// module chunks = 0